
import axiosInstance from "../config/Axios"

import { handleResErrors } from "./utils";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQueryClient } from "react-query";
import { useCustomToast } from "../pages/Contexts/ToastContext";
import { setIsLoading, toggleDialog } from "../redux/Slices/Global/globalSlice";


/* ---------------------- Cover (color or image) ---------------------- */

// payload: { id, data: { type: 'color'|'image', value: '#hex'|string } }
const updateCampaignCover = async (payload) => {
    const { data } = await axiosInstance.put(`/cover/${payload.id}/campaign`, payload.data);
    return data.data;
};

export const useUpdateCampaignCoverMutation = () => {
    const { showToast } = useCustomToast();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const { campaignDetails, isLoading } = useSelector((s) => s.global) ?? {};
    const interactive = window.location.pathname.includes("interactive")
        ? "interactive"
        : "normal";

    return useMutation(updateCampaignCover, {
        onMutate: () => {
            dispatch(setIsLoading(true))
        },
        onSuccess: (variables) => {
            dispatch(toggleDialog('campaignSettings'))

            queryClient.invalidateQueries(['getCampaign', campaignDetails.id])
            queryClient.invalidateQueries({ queryKey: [`allCampaigns-${interactive}`] });
            queryClient.invalidateQueries({ queryKey: [`getCampaigns`] });


        },
        onError: (err) => handleResErrors(err, showToast),
    });
};